import type { parseCountry } from 'react-international-phone';

type CountryMaskFormat = ReturnType<typeof parseCountry>['format'];

export const getMaxCountryMaskFormat = (format: CountryMaskFormat, prefix: string, maxCount = 27) => {
  const stringFormat = typeof format === 'string' ? format : format?.default;
  const maxCharacterMask = Array.from({ length: maxCount - prefix.length }, () => '.').join('');

  if (!stringFormat) {
    return maxCharacterMask;
  }

  return stringFormat + maxCharacterMask.slice(stringFormat.length);
};
